<!--
 * @Description: 视频中心
 * @Author: zml
 * @Date: 2023-04-13 18:09:06
 * @LastEditors: zml
 * @LastEditTime: 2023-08-14 10:49:49
-->
<template>
  <div class="video">
    <div class="container">
      <div class="video-box">
        <div class="title">{{ $hs($route.query.zhTit,$route.query.enTit,$route.query.esTit) }}</div>
        <div class="videos">
          <div class="cell" v-for="(item,index) in videoList" :key="index">
            <div class="video">
              <img :src="item.imgUrl" :alt="item.title" srcset />
              <div class="play-btn" @click="playClick(item.videoUrl)">
                <div class="triangle"></div>
              </div>
            </div>
            <div class="pro-detail" :style="{backgroundColor: item.productUrl ? '#ff6000':'#ccc'}">
              <a :href="item.productUrl">{{ item.productUrl ? $t('GA.detailBtn') : $t('GA.noDetailBtn') }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="paging">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryParam.pageNo"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="totalRows"
        ></el-pagination>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="videoDialog">
      <el-dialog :title="$t('GA.Video_playback')" :visible.sync="dialogVisible" :before-close="handleClose">
        <span>
          <video ref="videoPlayer" :src="videoUrl" type="video/mp4" style="max-height:580px;max-width:100%" controls autoplay></video>
        </span>
        <span slot="footer" class="dialog-footer"></span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { VideoGetListPage } from '@/api/home'
import transformMark from '@/utils/water'
export default {
  name: 'videoPage',
  data() {
    return {
      dialogVisible: false,
      videoUrl: '',
      videoList: [],
      queryParam: {
        pageNo: 1,
        pageSize: 20,
        sortField: '',
        sortOrder: '',
        cl_Nu: '',
        isAnd: false,
        conditionals: [],
        videoCategoryId: 0
      },
      totalRows: 0,
      totalPage: 0,
      currentPage1: 5
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const loading = this.$loading({
        lock: true,
        text: this.$t('GA.loading'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      // 视频
      this.queryParam.videoCategoryId = Number(this.$route.query.id) || 0
      VideoGetListPage(this.queryParam).then(res => {
        if (res.success) {
          this.totalRows = res.data.totalRows
          this.videoList = res.data.rows
          this.videoList.forEach(item => {
            transformMark(item.imgUrl + '?imageMogr2/thumbnail/800x').then(result => {
              item.imgUrl = result
            })
          })
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.$message.error(err)
      }).finally(() => {
        loading.close()
      })
    },
    // 关闭视频
    handleClose(done) {
      done()
      this.videoUrl = ''
    },
    // 点击播放icon
    playClick(videoUrl) {
      this.videoUrl = videoUrl
      this.dialogVisible = true
    },
    // 分页大小操作
    handleSizeChange(pageSize) {
      this.queryParam.pageNo = 1
      this.queryParam.pageSize = pageSize
      this.initData()
    },
    // 分页翻页操作
    handleCurrentChange(pageNo) {
      sessionStorage.setItem('activePageNo', pageNo)
      this.queryParam.pageNo = pageNo
      this.initData()
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  min-height: 46vh;
  padding: 10px 0;
  .video-box {
    .title {
      height: 66px;
      font-size: 50px;
      font-weight: bold;
      color: #333c4f;
      margin: 40px 0 30px 0;
    }
    .videos {
      display: flex;
      flex-wrap: wrap;

      .cell {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 285px;
        height: 214px;
        margin: 0 20px 20px 0;
        background-color: rgb(248, 248, 248);
        border-radius: 8px;
        overflow: hidden;
        &:nth-child(4n) {
          margin-right: 0px;
        }

        .video {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 285px;
          height: 214px;
          img {
            width: 285px;
            height: 214px;
            object-fit: cover;
          }

          .play-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 20px;
            right: 20px;
            width: 42px;
            height: 42px;
            opacity: 0.6;
            background: #000000;
            border-radius: 50%;
            cursor: pointer;
            &:hover {
              transform: scale(1.2);
              .triangle {
                border-left: 18px solid #f4400f;
              }
            }
            .triangle {
              margin: 0 -6px 0 0;
              border-left: 18px solid #fff;
              border-top: 10px solid transparent; /*改变值可以改变三角形的颜色和尺寸*/
              border-bottom: 10px solid transparent;
            }
          }
        }

        .pro-detail {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 36px;
          line-height: 36px;
          text-align: center;
          // box-shadow: 0px 0px 10px 6px #fff;
          display: block;

          a {
            display: inline-block;
            width: 100%;
            height: 36px;
            font-size: 14px;
            color: #fff;
            text-decoration: none;
          }
        }

        // &:hover {
        //   .pro-detail {
        //     display: block;
        //   }
        // }
      }
    }
  }
  .paging {
    display: flex;
    justify-content: center;
    padding: 20px;
  }
}

:deep .el-dialog__body {
  max-height: 670px;
  display: flex;
  justify-content: center;
  align-content: center;
  background-color: #000;
  padding: 0 !important;
  margin: 0 20px;
}
</style>>
